import React from "react";

const base = (extra = {}) => ({
    width: 18, height: 18, viewBox: "0 0 24 24", fill: "none",
    stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round",
    ...extra,
});

export const Icono = {
    Users: (p) => (
        <svg {...base()} {...p}>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    UserPlus: (p) => (
        <svg {...base()} {...p}>
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="8.5" cy="7" r="4" />
            <line x1="20" y1="8" x2="20" y2="14" />
            <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
    ),
    Phone: (p) => (
        <svg {...base()} {...p}>
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
    ),
    Star: (p) => (
        <svg {...base()} {...p}>
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
    ),
    Target: (p) => (
        <svg {...base()} {...p}>
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="6" />
            <circle cx="12" cy="12" r="2" />
        </svg>
    ),
    Eye: (p) => (
        <svg {...base()} {...p}>
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    MousePointer: (p) => (
        <svg {...base()} {...p}>
            <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" />
            <path d="M13 13l6 6" />
        </svg>
    ),
    Dollar: (p) => (
        <svg {...base()} {...p}>
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
    ),
    Wallet: (p) => (
        <svg {...base()} {...p}>
            <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
            <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
            <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
        </svg>
    ),
    Megaphone: (p) => (
        <svg {...base()} {...p}>
            <path d="M3 11l18-8v18l-18-8v-2z" />
            <path d="M11 11.5v6a2.5 2.5 0 0 1-5 0V13" />
        </svg>
    ),
    Clock: (p) => (
        <svg {...base()} {...p}>
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    XCircle: (p) => (
        <svg {...base()} {...p}>
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    CheckCircle: (p) => (
        <svg {...base()} {...p}>
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Calendar: (p) => (
        <svg {...base()} {...p}>
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Lightbulb: (p) => (
        <svg {...base()} {...p}>
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M12 2a7 7 0 0 0-4 12.74V17h8v-2.26A7 7 0 0 0 12 2z" />
        </svg>
    ),
    MapPin: (p) => (
        <svg {...base()} {...p}>
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    TrendingUp: (p) => (
        <svg {...base()} {...p}>
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
        </svg>
    ),
    TrendingDown: (p) => (
        <svg {...base()} {...p}>
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
            <polyline points="17 18 23 18 23 12" />
        </svg>
    ),
    Trophy: (p) => (
        <svg {...base()} {...p}>
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
            <path d="M4 22h16" />
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
        </svg>
    ),
    Filter: (p) => (
        <svg {...base()} {...p}>
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
    ),
    BarChart: (p) => (
        <svg {...base()} {...p}>
            <line x1="12" y1="20" x2="12" y2="10" />
            <line x1="18" y1="20" x2="18" y2="4" />
            <line x1="6" y1="20" x2="6" y2="16" />
        </svg>
    ),
    AlertTriangle: (p) => (
        <svg {...base()} {...p}>
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
    ),
    ImageIcon: (p) => (
        <svg {...base()} {...p}>
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
        </svg>
    ),
    Search: (p) => (
        <svg {...base()} {...p}>
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
    ),
    Female: (p) => (
        <svg {...base()} {...p}>
            <circle cx="12" cy="9" r="5" />
            <line x1="12" y1="14" x2="12" y2="22" />
            <line x1="9" y1="18" x2="15" y2="18" />
        </svg>
    ),
    Male: (p) => (
        <svg {...base()} {...p}>
            <circle cx="10" cy="14" r="5" />
            <line x1="14" y1="10" x2="20" y2="4" />
            <polyline points="15 4 20 4 20 9" />
        </svg>
    ),
    ArrowUp: (p) => (
        <svg {...base()} {...p}>
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
        </svg>
    ),
    ArrowDown: (p) => (
        <svg {...base()} {...p}>
            <line x1="12" y1="5" x2="12" y2="19" />
            <polyline points="19 12 12 19 5 12" />
        </svg>
    ),
};

// Círculo con icono dentro (estilo KPI card)
export function IconBubble({ children, color = "#7BC74D", size = 36 }) {
    return (
        <div style={{
            width: size, height: size,
            borderRadius: "50%",
            backgroundColor: `${color}1f`,
            color,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
        }}>
            {children}
        </div>
    );
}

// Avatar con iniciales (para leads y closers)
export function Avatar({ nombre, size = 36, bg }) {
    const iniciales = (nombre || "?")
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(w => w[0]?.toUpperCase())
        .join("");
    const palette = ["#7BC74D", "#1877F2", "#f0a500", "#17a2b8", "#e83e8c", "#6c5ce7", "#fd7e14"];
    const color = bg || palette[(nombre?.length || 0) % palette.length];
    return (
        <div style={{
            width: size, height: size,
            borderRadius: "50%",
            backgroundColor: color,
            color: "#fff",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: size * 0.38,
            flexShrink: 0,
        }}>
            {iniciales}
        </div>
    );
}
